import { BuyCreditsDto } from '@tribuu-api';

export namespace CreditsActions {
  /** Carga balance + transacciones del usuario autenticado. */
  export class LoadCredits {
    static readonly type = '[Credits] Load Credits';
  }

  /**
   * Inicia el checkout de Stripe para comprar créditos. El state hace la
   * llamada y guarda la `checkoutUrl`; el componente la lee para redirigir.
   */
  export class Checkout {
    static readonly type = '[Credits] Checkout';
    constructor(
      public readonly buyCreditsDto: BuyCreditsDto,
      public readonly successUrl: string,
      public readonly cancelUrl: string
    ) {}
  }

  /**
   * Confirma el pago con el backend tras el redirect de Stripe.
   * Persiste `creditsAdded` en el state.
   */
  export class ApplySuccess {
    static readonly type = '[Credits] Apply Success';
    constructor(public readonly credits: number) {}
  }

  export class Reset {
    static readonly type = '[Credits] Reset';
  }
}
